<template>
  <div class="tool_cell">
    <span class="required">*</span>文字说明
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {}
    };
  }
};
</script>



 